/* Wondernara ATEEZ separate-raffle discovery in full cart and cart drawer.
   The cart remains shoppable, and no product is added automatically. */
(() => {
  'use strict';
  if(window.__wnSecondRaffleCartReady) return;
  window.__wnSecondRaffleCartReady=true;
  const ROOT='[data-wn-cart-cross-events]';
  const ITEM='[data-js-cart-item]';
  const ORGANIZERS=['APPLEMUSIC','MAKESTAR','JUMPUP','KPOPSTORE','SOUNDWAVE','BEATROAD','MUSINSA'];
  let pending=false;
  function update() {
    document.querySelectorAll(ROOT).forEach(root=>{
      const scope=root.closest('#site-cart-sidebar')||root.closest('.cart-section')||document;
      const lines=[...scope.querySelectorAll(ITEM)]
        .map(el=>String(el.getAttribute('data-title')||'').toUpperCase())
        .filter(title=>title.includes('ATEEZ')&&/VIDEO CALL|VIDEO FANSIGN/.test(title)&&/PART[ .:]*6\b/.test(title))
        .filter(title=>!title.includes('TEST ONLY')&&!title.includes('NOT FOR SALE'));
      const chosen=new Set();
      lines.forEach(title=>ORGANIZERS.forEach(org=>{if(title.includes(org))chosen.add(org)}));
      let shown=0;
      root.querySelectorAll('[data-wn-organizer]').forEach(card=>{
        const isEligible=lines.length>0&&!chosen.has(card.dataset.wnOrganizer)&&shown<2;
        card.hidden=!isEligible;
        if(isEligible)shown++;
      });
      root.hidden=shown===0;
      if(!shown)return;
      const count=chosen.size||lines.length;
      const title=root.querySelector('[data-wn-cart-heading]');
      const desc=root.querySelector('[data-wn-cart-intro]');
      const details=root.querySelector('[data-wn-cart-details]');
      if(title)title.textContent='Did you know you can join multiple ATEEZ video call events?';
      if(desc)desc.textContent=count===1
        ? 'These raffles are still open! After adding your first application to the cart, Quick Apply can reuse matching personal details with one tap. Just review the required contact app and any new questions.'
        : 'You already have '+count+' separate ATEEZ raffles in your cart! More events are still open, and Quick Apply can reuse matching details if you choose to join another.';
      if(details && details.dataset.wnAutoCount!==String(count)){
        // Keep mobile discovery and the narrow drawer collapsed by default.
        // Customers can still open the options; never override their tap.
        const compact=(window.matchMedia&&window.matchMedia('(max-width: 760px)').matches)||!!root.closest('#site-cart-sidebar');
        details.open=count===1&&!compact;
        details.dataset.wnAutoCount=String(count);
      }
    });
  }
  function schedule() {
    if(pending)return;
    pending=true;
    requestAnimationFrame(()=>{pending=false;update()});
  }
  function boot() {
    document.querySelectorAll('cart-form').forEach(form=>{
      if(form.dataset.wnSecondRaffleObserved==='true')return;
      form.dataset.wnSecondRaffleObserved='true';
      new MutationObserver(schedule).observe(form,{childList:true,subtree:false});
      form.addEventListener('cart-updated',schedule);
    });
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();